import './RAAccordionBody.scss';

// @ vendors
import React from 'react';
import PropTypes from 'prop-types';
import { recordEventCustomOnly } from 'utilities/uTagging';
// @ utilities
import { formatText } from 'core/i18n';
// @ assets
import ArrowUp from 'assets/icons/icon-arrow-up-red.svg';
// @ constants
import { TEST_PROCESS_STEP_STEP_4, EVENT_CATEGORY_SUITABILITY_TEST } from 'constants/uTagConstants/RAConstants';

export const RAAccordionBody = ({ expandAccordionRow, id, title, rowIndex, text, isExpanded }) => {
    const handleClick = () => {
        expandAccordionRow(id);

        const lessInfoEventTag = () => {
            const zeroPad = (num, places) => String(num).padStart(places, '0');

            return `${zeroPad(rowIndex + 1, 2)} ${title} - menos información`;
        };

        recordEventCustomOnly({
            accionEvento: TEST_PROCESS_STEP_STEP_4,
            categoriaEvento: EVENT_CATEGORY_SUITABILITY_TEST,
            etiquetaEvento: lessInfoEventTag(),
        });

    };

    return (
        <div className="ra-accordion-body">
            <p className="ra-accordion-body__text">{text}</p>
            {isExpanded && (
                <div className="ra-accordion-body__less" onClick={handleClick}>
                    {formatText('initialAddInfoSection-accordionTitleLessInfo')}
                    <img src={ArrowUp} alt="ArrowUp" className="svg-arrow-up" />
                </div>
            )}
        </div>
    );
};

RAAccordionBody.propTypes = {
    title: PropTypes.string,
    rowIndex: PropTypes.number,
    id: PropTypes.string.isRequired,
    expandAccordionRow: PropTypes.func.isRequired,
    text: PropTypes.string,
    isExpanded: PropTypes.bool,
};
